import MainLayout from "../../../layouts/main/main_layout";
import HospitalLayout from "../../../layouts/hospitals/hospital_layout";
import {
  createHospitalFacility,
  deleteHospitalFacility,
  getHospitalFacilities,
  updateHospitalFacility,
} from "../../../services/hospitals/hospitals";
import HospitalMasterList from "../components/hospital_master_list/hospital_master_list";

export default function HospitalFacilities() {
  return (
    <MainLayout>
      <HospitalLayout>
        <HospitalMasterList
          itemLabel="Facility"
          itemLabelPlural="Facilities"
          queryKey="hospital-facilities"
          getItems={getHospitalFacilities}
          createItem={createHospitalFacility}
          updateItem={updateHospitalFacility}
          deleteItem={deleteHospitalFacility}
        />
      </HospitalLayout>
    </MainLayout>
  );
}
